import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Table from "../../../core/common/dataTable/index";
import apiDefinitions from "../../../api/apiDefinitions";

import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { Pagination, Form } from "react-bootstrap";
import FileUpload from "./fileUploader";

import { useNavigate } from "react-router-dom";
import { parse, format } from "date-fns";

const SubBudget = () => {
  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(10), (val, index) => currentYear + index);
  const { id } = useParams<{ id: string }>();
  const route = all_routes;
  const navigate = useNavigate();
  const [campaignList, setCampaignList] = useState([]);
  const [year, setYear] = useState<string>("");
  const [budget, setBudget] = useState<string>("");
  const [uploadedFile, setUploadedFile] = useState<File[]>([]);
  const [leads, setLeads] = useState<Lead[]>([]);
  const [fieldErrors, setFieldErrors] = useState<any>({
    subBudgetName: "",
    budget: "",
    file: "",
  });
  const [clearFileUploader, setClearFileUploader] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [initalError, setInitalError] = useState(false);
  const [subBudgetList, setSubBudgetList] = useState<any>([]);

  const hasDataLoaded = useRef(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchKey, setSearchKey] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [leadStatus, setLeadStatus] = useState("");
  const [leadPriority, setLeadPriority] = useState("");
  const [budegtYear, setBudgetYear] = useState("");
  const [chequeCollected, setChequeCollected] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [subBudgetName, setSubBudgetName] = useState("");
  const [subBudgetType, setSubBudgetType] = useState("");
  const [requestingBudget, setRequestingBudget] = useState("");
  const [availableBudget, setAvailableBudget] = useState("");
  const [subBudgetDescription, setSubBudgetDescription] = useState("");
  const [subBudgetNameIsValid, setSubBudgetNameIsValid] = useState(false);
  const [subBudgetTypeIsValid, setSubBudgetTypeIsValid] = useState(false);
  const [requestingBudgetIsValid, setRequestingBudgetIsValid] = useState(false);
  const [subBudgetDescriptionIsValid, setSubBudgetDescriptionIsValid] =
    useState(false);

  const [paymentMethod, setPaymentMethod] = useState("Cash");
  const [paymentParty, setPaymentParty] = useState("Internal");
  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [internalParty, setInternalParty] = useState("");
  const [externalParty, setExternalParty] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [isIssueDateInvalid, setIsIssueDateInvalid] = useState(false);

  const [isInternalPartyInvalid, setIsInternalPartyInvalid] = useState(false);
  const [isExternalPartyInvalid, setIsExternalPartyInvalid] = useState(false);
  const [beneficiaryNames, setBeneficiaryNames] = useState<any[]>([]);
  const [roleId, setRoleId] = useState<number | undefined>(undefined);
  const [beneficiaryBankDetails, setBeneficiaryBankDetails] = useState({
    bankName: "",
    bankAccountNumber: "",
    accountHolderName: "",
    bankBranch: "",
    bankBranchCode: "",
  });

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankAccountNumber: "",
    accountHolderName: "",
    bankBranch: "",
    bankBranchCode: "",
  });

  interface Budget {
    id: number;
    requestBudget: number;
    year: string;
    requestedBy: string;
    fileJustifications: string[];
    approvedAmount: number;
    remainingAmount: number;
    approvedBy: string;
    startDate: string;
    endDate: string;
    rejectionNote: string | null;
    reason: string;
    status: {
      id: number;
      name: string;
      color: string;
    }[];
    approveRejectStatus: string;
  }

  interface Lead {
    id: number;
    name: string;
    requestAmount: string;
    approvedAmount: string;
    remainingAmount: string;
    requestBy: string;
    status: string;
    budgetYear: string;
    budget: Budget;
    requestDate: string;
    approveRejectDate: string;
    isChequeCollected: boolean;
    approveRejectStatus: string;
  }

  interface SubBudget {
    id: number;
    name: string;
  }

  const handleErrors = (error: any) => {
    setFieldErrors((previouseErrors: any) => {
      return { ...previouseErrors, ...error };
    });
  };

  const location = useLocation();
  const isLinkActive = (route: string) => {
    return location.pathname === route;
  };

  const handleFileSelect = (files: any) => {
    setUploadedFile(files);
  };

  const handleClear = () => {
    setSubBudgetName("");
    setRequestingBudget("");
    setSubBudgetDescription("");
    setUploadedFile([]);
    setClearFileUploader(true);
    setSubBudgetType("");
    setAvailableBudget("");
    setPaymentMethod("Cash");
    setPaymentParty("Internal");

    setBankDetails({
      bankName: "",
      bankAccountNumber: "",
      accountHolderName: "",
      bankBranch: "",
      bankBranchCode: "",
    });

    // Clear errors
    setSubBudgetDescriptionIsValid(false);
    setRequestingBudgetIsValid(false);
    setSubBudgetNameIsValid(false);
    setSubBudgetTypeIsValid(false);
  };

  useEffect(() => {
    if (clearFileUploader) {
      setClearFileUploader(false);
    }
  }, [clearFileUploader]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setEmployeeId(decodedToken.serial_number);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    console.log("file error", fieldErrors.file);
  }, [fieldErrors.file]);

  const handleSubmit = () => {
    let isvalid = true;

    if (subBudgetName === "") {
      setSubBudgetNameIsValid(true);
      isvalid = false;
    } else {
      setSubBudgetNameIsValid(false);
    }

    if (requestingBudget === "" || !/^\d+$/.test(requestingBudget)) {
      setRequestingBudgetIsValid(true);
      isvalid = false;
    } else {
      setRequestingBudgetIsValid(false);
    }

    if (subBudgetDescription === "") {
      setSubBudgetDescriptionIsValid(true);
      isvalid = false;
    } else {
      setSubBudgetDescriptionIsValid(false);
    }

    if (uploadedFile.length === 0) {
      handleErrors({ file: "File is required" });
      isvalid = false;
    }

    if (subBudgetType === "") {
      setSubBudgetTypeIsValid(true);
      isvalid = false;
    } else {
      setSubBudgetTypeIsValid(false);
    }

    // if (internalParty === "" || externalParty === "") {
    //   setIsInternalPartyInvalid(true);
    //   isvalid = false;
    // } else {
    //   setIsInternalPartyInvalid(false);
    // }

    if (paymentParty === "Internal" && internalParty === "") {
      setIsInternalPartyInvalid(true);
      isvalid = false;
    } else {
      setIsInternalPartyInvalid(false);
    }

    if (paymentParty === "External" && externalParty === "") {
      setIsExternalPartyInvalid(true);
      isvalid = false;
    } else {
      setIsExternalPartyInvalid(false);
    }

    if (issueDate === "") {
      setIsIssueDateInvalid(true);
      isvalid = false;
    } else {
      setIsIssueDateInvalid(false);
    }

    if (fieldErrors.file === "" && isvalid) {
      // Collect all form data
      const formData = new FormData();

      if (uploadedFile && uploadedFile.length > 0) {
        uploadedFile.forEach((file) => {
          formData.append("files", file);
        });
      }

      const payload = {
        requestAmount: requestingBudget,
        name: subBudgetName,
        requestBy: employeeId,
        description: subBudgetDescription,
        paymentMethod: paymentMethod,
        bankName: null as string | null,
        bankAccountNumber: null as string | null,
        accountHolderName: null as string | null,
        bankBranch: null as string | null,
        bankBranchCode: null as string | null,
        paymentParty: paymentParty,
        internalParty: {
          serial_number: Number(internalParty),
        },
        issueDate: issueDate,
        stakeholder: {
          id: Number(externalParty),
        },
      };

      if (paymentMethod === "bank payment" && paymentParty === "Internal") {
        payload.bankName = bankDetails.bankName || null;
        payload.bankAccountNumber = bankDetails.bankAccountNumber || null;
        payload.accountHolderName = bankDetails.accountHolderName || null;
        payload.bankBranch = bankDetails.bankBranch || null;
        payload.bankBranchCode = bankDetails.bankBranchCode || null;
      }

      if (paymentMethod === "bank payment" && paymentParty === "External") {
        payload.bankName = beneficiaryBankDetails.bankName || null;
        payload.bankAccountNumber =
          beneficiaryBankDetails.bankAccountNumber || null;
        payload.accountHolderName =
          beneficiaryBankDetails.accountHolderName || null;
        payload.bankBranch = beneficiaryBankDetails.bankBranch || null;
        payload.bankBranchCode = beneficiaryBankDetails.bankBranchCode || null;
      }

      console.log("Payload", payload);

      formData.append("subBudgetDto", JSON.stringify(payload));

      formData.forEach((value, key) => {
        console.log(key, value);
      });

      Swal.fire({
        title: "Do You Want Request A New Sub-Budget?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Request",
        denyButtonText: `Don't Request`,
      }).then((result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            console.log("currentTime", currentTime);
            console.log("Token", token);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Requesting Sub-Budget...");
              // Token is valid, proceed with the API call
              apiDefinitions
                .createSubBudget(token, id, subBudgetType, formData)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Sub-Budget Requested Successfully", {
                      duration: 5000,
                    });
                    window.location.reload();
                  } else if (response.data.code === 400) {
                    toast.dismiss(toastId);
                    toast.error(response.data.message);
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Request Sub-Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extract only the date in YYYY-MM-DD format
  };

  interface Column {
    title: string;
    dataIndex: string;
    render?: (text: any, record: Budget) => JSX.Element;
  }

  const refreshCampaigns = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    if (!hasDataLoaded.current) {
      hasDataLoaded.current = true;
      return;
    }

    const offset = currentPage - 1;

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const toastId = toast.loading("Loading Data...");
        apiDefinitions
          .getSubBudgetByStatus(token, id, 1, offset, itemsPerPage)
          .then((response: any) => {
            if (response.data.code === 200) {
              console.log("Sub Budget: ", response.data.data);
              setTotalPages(response.data.data.totalPages);
              setCurrentPage(response.data.data.pageable.pageNumber + 1);
              setLeads(response.data.data.content);
              toast.dismiss(toastId);
              toast.success("Data Loaded", {
                duration: 5000,
              });
            } else {
              toast.dismiss(toastId);
              toast.error("Failed to Load Data");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  useEffect(() => {
    refreshCampaigns();
  }, [itemsPerPage, currentPage, refresh]);

  const getBudgetDetails = () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getBudgetByBudgetId(token, id).then((response: any) => {
          if (response.data.code === 200) {
            console.log("Sub Budgettttt: ", response.data.data[0].year);
            setBudgetYear(response.data.data[0].year);
          } else {
            toast.error("Failed to Load Data");
          }
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  useEffect(() => {
    if (uploadedFile.length === 0) {
      if (initalError) {
        handleErrors({ file: "File is required" });
      } else {
        setInitalError(true);
      }
    } else {
      handleErrors({ file: "" });
    }
  }, [uploadedFile]);

  useEffect(() => {
    const modalElement = document.getElementById("con-close-modal");
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleClear);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleClear);
      }
    };
  }, []);

  const handleSearch = () => {
    setSearchClicked(!searchClicked);
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleClose = () => {
    setSearchClicked(!searchClicked);
    setSearchKey("");
    setLeadPriority("");
    setLeadStatus("");
  };

  useEffect(() => {
    const modalElement = document.getElementById("con-close-modal");
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleClear);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleClear);
      }
    };
  }, []);

  const handleChequeCollected = (id: number) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const loadingToastId = toast.loading("Collecting payment...");
        apiDefinitions
          .chequeCollected(token, id, true)
          .then((response: any) => {
            if (response.data.code === 200) {
              toast.dismiss(loadingToastId);
              setRefresh(!refresh);
              toast.success("Payment Collected Successfully");
            } else {
              toast.dismiss(loadingToastId);
              toast.error("Failed to Collect Payment");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    if (!id) {
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions
          .getAllSubTypesByBudgetId(token, id)
          .then((response) => {
            if (response.data.code === 200) {
              console.log("Sub Budget: ", response.data.data);
              setSubBudgetList(response.data.data.subBudgets);
            } else {
              console.error("Failed to fetch call stats");
            }
          })
          .catch((error) => {
            console.error("Error fetching call stats", error);
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  }, []);

  const handleSubbugetDetails = (e: any, approveAmount: string) => {
    setAvailableBudget(approveAmount);
    console.log("Available Budgetttttttttttttttttt", approveAmount);
    setSubBudgetType(e.target.value);
  };

  useEffect(() => {
    console.log("Selected Payment: ", subBudgetType);
  }, [subBudgetType]);

  function formatISTDate(dateString: string): string {
    // Parse the date string with the correct format
    const date = parse(
      dateString,
      "EEE MMM dd HH:mm:ss 'IST' yyyy",
      new Date()
    );

    if (isNaN(date.getTime())) {
      console.error("Invalid date string:", dateString);
      return ""; // Return an empty string or handle the error as needed
    }

    // Format the date as "M/d/yyyy"
    return format(date, "M/d/yyyy");
  }

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getMarketingEmployeeList().then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setEmployeeList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getAllBeneficiaryNames(token).then((response: any) => {
          setBeneficiaryNames(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    if (externalParty) {
      try {
        const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp && decodedToken.exp > currentTime) {
          apiDefinitions
            .getAllBeneficiaryBankDetails(token, externalParty)
            .then((response: any) => {
              console.log("Bank Details: ", response.data.data);
              setBeneficiaryBankDetails(response.data.data[0]);
            });
        } else {
          console.log("Session expired. Please log in again.");
          navigate(route.login);
        }
      } catch (error) {
        console.error("Invalid token or unable to decode", error);
      }
    }
  }, [externalParty]);

  useEffect(() => {
    setBankDetails({
      bankName: "",
      bankAccountNumber: "",
      accountHolderName: "",
      bankBranch: "",
      bankBranchCode: "",
    });
  }, [paymentParty]);

  useEffect(() => {
    // If paymentParty is "External" and paymentMethod is "Cash", switch to "Cheque"
    if (paymentParty === "External" && paymentMethod === "Cash") {
      setPaymentMethod("Cheque"); // Or "bank payment" if preferred
    }
  }, [paymentParty, paymentMethod]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      setRoleId(decodedToken.role_id); // Set the role_id in state
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  }, []);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">Annual Sub-Budget</h4>
                  </div>
                  <div className="col-8 text-end">
                    <Link
                      to="/budget/approvedBudgets"
                      className="btn btn-primary"
                    >
                      <i
                        className="feather-arrow-left"
                        style={{ fontSize: "17px", marginRight: "5px" }}
                      />
                      Back to list
                    </Link>
                  </div>
                </div>
              </div>
              <div className="campaign-tab">
                <ul className="nav">
                  <li>
                    <Link
                      to={`/budget/subBudgets/${id}`}
                      className={
                        isLinkActive(`/budget/subBudgets/${id}`) ? "active" : ""
                      }
                    >
                      Approved Sub-Budgets
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/budget/subBudgets/requestedSubBudget/${id}`}
                      className={
                        isLinkActive(
                          `/budget/subBudgets/requestedSubBudget/${id}`
                        )
                          ? "active"
                          : ""
                      }
                    >
                      Requested Sub-Budgets
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/budget/subBudgets/rejectedSubBudget/${id}`}
                      className={
                        isLinkActive(
                          `/budget/subBudgets/rejectedSubBudget/${id}`
                        )
                          ? "active"
                          : ""
                      }
                    >
                      Rejected Sub-Budgets
                    </Link>
                  </li>
                </ul>
              </div>
              {/* Campaign Tab */}

              <div className="col-md-12">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-1 mt-3">
                          <Form.Select
                            value={itemsPerPage}
                            onChange={(event) =>
                              setItemsPerPage(parseInt(event.target.value, 10))
                            }
                            aria-label="Select number of items per page"
                            className="w-auto"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </Form.Select>
                        </div>
                        <div className="col-sm-11 mt-3 text-end">
                          {roleId !== 3 && (
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light mt-1 me-1"
                              data-bs-toggle="modal"
                              data-bs-target="#con-close-modal"
                              onClick={() => {
                                setInitalError(false);
                                setFieldErrors({ file: "" });
                                getBudgetDetails();
                              }}
                            >
                              Request New Sub-Budget
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table text-nowrap table-striped">
                          <thead>
                            <tr>
                              <th scope="col">Sub-Budget Name</th>
                              <th scope="col">Budget Year</th>
                              <th scope="col">Sub-Budget Status</th>
                              <th scope="col">Approved Amount (LKR)</th>
                              <th scope="col">Approved Date</th>
                              <th scope="col">Requested Date</th>
                              <th scope="col">Payment Collection</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leads.length > 0 ? (
                              leads.map((lead, index) => (
                                <tr key={index}>
                                  <td>{lead.name}</td>
                                  <td>{lead.budgetYear}</td>
                                  <td>
                                    <span className="badge bg-soft-secondary">
                                      {lead.approveRejectStatus}
                                    </span>
                                  </td>

                                  <td>{lead.requestAmount}</td>

                                  <td>
                                    {lead.approveRejectDate
                                      ? formatISTDate(lead.approveRejectDate)
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {lead.requestDate
                                      ? new Date(
                                          lead.requestDate
                                        ).toLocaleDateString()
                                      : ""}
                                  </td>
                                  <td>
                                    <div className="hstack gap-2 fs-15">
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          disabled={
                                            lead.isChequeCollected === true ||
                                            lead.approveRejectStatus !==
                                              "Payment Collection Pending"
                                          }
                                          defaultChecked={
                                            lead.isChequeCollected || false
                                          }
                                          onClick={() => {
                                            handleChequeCollected(lead.id);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="hstack gap-2 fs-15">
                                      <Link
                                        to={`${route.viewSubBudget.replace(
                                          ":id",
                                          lead.id.toString()
                                        )}`}
                                        className="btn btn-icon btn-md btn-success"
                                      >
                                        <i
                                          className="feather-eye"
                                          style={{ fontSize: "17px" }}
                                        />
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={9} className="text-center">
                                  No Data Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <Pagination className="mt-3 justify-content-center">
                        <Pagination.Prev
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="con-close-modal"
        tabIndex={-1}
        aria-labelledby="con-close-modal-label"
        aria-hidden="true"
      >
        <div
          className="modal-dialog"
          style={{ maxWidth: "900px", width: "90%", margin: "0 auto" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="con-close-modal-label">
                Request New Sub-Budget for {budegtYear}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label" htmlFor="validationCustom02">
                    Sub-Budget Name
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className={`form-control ${
                        subBudgetNameIsValid ? "is-invalid" : ""
                      }`}
                      id="validationCustom02"
                      placeholder="Sub-Budget Name"
                      value={subBudgetName}
                      onChange={(e) => setSubBudgetName(e.target.value)}
                      required
                    />
                    {subBudgetNameIsValid && (
                      <div className="invalid-feedback">
                        Please enter a sub budget name
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Sub-Activity Type
                  </label>
                  <select
                    className={`form-select ${
                      subBudgetTypeIsValid ? "is-invalid" : ""
                    }`}
                    id="validationCustomContactMethod"
                    value={subBudgetType}
                    onChange={(e) => {
                      const selectedBudget = subBudgetList.find(
                        (budget: SubBudget) =>
                          budget.id === parseInt(e.target.value)
                      );
                      handleSubbugetDetails(e, selectedBudget?.remainingAmount);
                    }}
                    required
                  >
                    <option value="">Select an option</option>
                    {subBudgetList.map((budget: SubBudget) => (
                      <option key={budget.id} value={budget.id}>
                        {budget.name}
                      </option>
                    ))}
                  </select>
                  {subBudgetTypeIsValid && (
                    <div className="invalid-feedback">
                      Please select a sub budget type
                    </div>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="form-label" htmlFor="validationCustom02">
                    Available Value
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      LKR
                    </span>
                    <input
                      type="text"
                      className={`form-control `}
                      id="validationCustom02"
                      placeholder="Available Value"
                      disabled
                      value={availableBudget}
                      // onChange={(e) => setRequestingBudget(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="form-label" htmlFor="validationCustom02">
                    Requesting Sub-Budget
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      LKR
                    </span>
                    <input
                      type="text"
                      className={`form-control ${
                        requestingBudgetIsValid ? "is-invalid" : ""
                      }`}
                      id="validationCustom02"
                      placeholder="Requesting Budget"
                      value={requestingBudget}
                      onChange={(e) => setRequestingBudget(e.target.value)}
                      required
                    />
                    {requestingBudgetIsValid && (
                      <div className="invalid-feedback">
                        Please enter a valid requesting budget
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <label
                    className="form-label"
                    htmlFor="validationCustomFollowUpDate"
                  >
                    Issue Date
                  </label>
                  <input
                    type="date"
                    className={`form-control ${
                      isIssueDateInvalid ? "is-invalid" : ""
                    }`}
                    id="validationCustomFollowUpDate"
                    value={issueDate}
                    onChange={(e) => setIssueDate(e.target.value)}
                    min={
                      new Date(new Date().setDate(new Date().getDate() + 5))
                        .toISOString()
                        .split("T")[0]
                    }
                    required
                  />
                  {isIssueDateInvalid && (
                    <div className="invalid-feedback">
                      Please select a sub-budget issue date.
                    </div>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <label className="form-label">Payment Party</label>
                  <div className="row align-items-center">
                    {/* Radio Buttons for Payment Party */}
                    <div className="col-md-6 d-flex align-items-center mb-3">
                      <div className="form-check me-4">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="internal"
                          name="paymentParty"
                          value="Internal"
                          checked={paymentParty === "Internal"}
                          onChange={(e) => {
                            setPaymentParty(e.target.value);
                          }}
                        />
                        <label className="form-check-label" htmlFor="internal">
                          Internal
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="external"
                          name="paymentParty"
                          value="External"
                          checked={paymentParty === "External"}
                          onChange={(e) => {
                            setPaymentParty(e.target.value);
                            if (paymentMethod === "Cash") {
                              setPaymentMethod("Cheque");
                            }
                          }}
                        />
                        <label className="form-check-label" htmlFor="external">
                          External
                        </label>
                      </div>
                    </div>

                    {/* Conditional Rendering for Internal Party */}
                    {paymentParty === "Internal" && (
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustomContactMethod"
                        >
                          Internal Party Name
                        </label>
                        <select
                          className={`form-select ${
                            isInternalPartyInvalid ? "is-invalid" : ""
                          }`}
                          id="validationCustomContactMethod"
                          value={internalParty}
                          onChange={(e) => {
                            setInternalParty(e.target.value);
                            setExternalParty("");
                          }}
                          required
                        >
                          <option value="">Select an option</option>
                          {employeeList.map((employeee) => (
                            <option
                              key={employeee.serial_number}
                              value={employeee.serial_number}
                            >
                              {employeee.name_in_full}
                            </option>
                          ))}
                        </select>
                        {isInternalPartyInvalid && (
                          <div className="invalid-feedback">
                            Please select an internal party name.
                          </div>
                        )}
                      </div>
                    )}

                    {/* Conditional Rendering for External Party */}
                    {paymentParty === "External" && (
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="validationCustomContactMethod"
                        >
                          External Party Name
                        </label>
                        <select
                          className={`form-select ${
                            isExternalPartyInvalid ? "is-invalid" : ""
                          }`}
                          id="validationCustomContactMethod"
                          value={externalParty}
                          onChange={(e) => {
                            setExternalParty(e.target.value);
                            setInternalParty("");
                          }}
                          required
                        >
                          <option value="">Select an option</option>
                          {beneficiaryNames.map((employeee) => (
                            <option key={employeee.id} value={employeee.id}>
                              {employeee.name}
                            </option>
                          ))}
                        </select>
                        {isExternalPartyInvalid && (
                          <div className="invalid-feedback">
                            Please select an external party name.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {paymentParty === "Internal" && (
                  <div className="col-md-12 mb-3 mt-3">
                    <label className="form-label">
                      Internal Payment Method
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="cash"
                            name="paymentMethod"
                            value="Cash"
                            checked={paymentMethod === "Cash"}
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                              // Reset bank details if switching away from Bank
                              setBankDetails({
                                bankName: "",
                                bankAccountNumber: "",
                                accountHolderName: "",
                                bankBranch: "",
                                bankBranchCode: "",
                              });
                            }}
                          />
                          <label className="form-check-label" htmlFor="cash">
                            Cash
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="cheque"
                            name="paymentMethod"
                            value="Cheque"
                            checked={paymentMethod === "Cheque"}
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                              // Reset bank details if switching away from Bank
                              setBankDetails({
                                bankName: "",
                                bankAccountNumber: "",
                                accountHolderName: "",
                                bankBranch: "",
                                bankBranchCode: "",
                              });
                            }}
                          />
                          <label className="form-check-label" htmlFor="cheque">
                            Cheque
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="bank"
                            name="paymentMethod"
                            value="bank payment"
                            checked={paymentMethod === "bank payment"}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="bank">
                            Bank
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {paymentParty === "External" && (
                  <div className="col-md-12 mb-3 mt-3">
                    <label className="form-label">
                      External Payment Method
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="cash"
                            name="paymentMethod"
                            value="Cash"
                            checked={paymentMethod === "Cash"}
                            disabled={true}
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                              setBankDetails({
                                bankName: "",
                                bankAccountNumber: "",
                                accountHolderName: "",
                                bankBranch: "",
                                bankBranchCode: "",
                              });
                            }}
                          />
                          <label className="form-check-label" htmlFor="cash">
                            Cash
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="cheque"
                            name="paymentMethod"
                            value="Cheque"
                            checked={paymentMethod === "Cheque"}
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                              setBankDetails({
                                bankName: "",
                                bankAccountNumber: "",
                                accountHolderName: "",
                                bankBranch: "",
                                bankBranchCode: "",
                              });
                            }}
                          />
                          <label className="form-check-label" htmlFor="cheque">
                            Cheque
                          </label>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-check">
                          <input
                            type="radio"
                            className="form-check-input"
                            id="bank"
                            name="paymentMethod"
                            value="bank payment"
                            checked={paymentMethod === "bank payment"}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="bank">
                            Bank
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {paymentMethod === "bank payment" &&
                  paymentParty === "Internal" && (
                    <div className="row mt-3">
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankName">
                          Bank Name
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankName"
                            placeholder="Bank Name"
                            value={bankDetails.bankName}
                            onChange={(e) =>
                              setBankDetails({
                                ...bankDetails,
                                bankName: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="bankAccountNumber"
                        >
                          Bank Account Number
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankAccountNumber"
                            placeholder="Bank Account Number"
                            value={bankDetails.bankAccountNumber}
                            onChange={(e) =>
                              setBankDetails({
                                ...bankDetails,
                                bankAccountNumber: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="accountHolderName"
                        >
                          Account Holder Name
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="accountHolderName"
                            placeholder="Account Holder Name"
                            value={bankDetails.accountHolderName}
                            onChange={(e) =>
                              setBankDetails({
                                ...bankDetails,
                                accountHolderName: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankBranch">
                          Bank Branch
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankBranch"
                            placeholder="Bank Branch"
                            value={bankDetails.bankBranch}
                            onChange={(e) =>
                              setBankDetails({
                                ...bankDetails,
                                bankBranch: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankBranchCode">
                          Bank Branch Code
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankBranchCode"
                            placeholder="Bank Branch Code"
                            value={bankDetails.bankBranchCode}
                            onChange={(e) =>
                              setBankDetails({
                                ...bankDetails,
                                bankBranchCode: e.target.value,
                              })
                            }
                            required
                          />
                        </div>
                      </div>
                    </div>
                  )}

                {paymentMethod === "bank payment" &&
                  paymentParty === "External" && (
                    <div className="row mt-3">
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankName">
                          Bank Name
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankName"
                            placeholder="Bank Name"
                            value={beneficiaryBankDetails.bankName}
                            // onChange={(e) =>
                            //   setBankDetails({
                            //     ...bankDetails,
                            //     bankName: e.target.value,
                            //   })
                            // }
                            disabled
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="bankAccountNumber"
                        >
                          Bank Account Number
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankAccountNumber"
                            placeholder="Bank Account Number"
                            value={beneficiaryBankDetails.bankAccountNumber}
                            // onChange={(e) =>
                            //   setBankDetails({
                            //     ...bankDetails,
                            //     bankAccountNumber: e.target.value,
                            //   })
                            // }
                            required
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="accountHolderName"
                        >
                          Account Holder Name
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="accountHolderName"
                            placeholder="Account Holder Name"
                            value={beneficiaryBankDetails.accountHolderName}
                            // onChange={(e) =>
                            //   setBankDetails({
                            //     ...bankDetails,
                            //     accountHolderName: e.target.value,
                            //   })
                            // }
                            required
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankBranch">
                          Bank Branch
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankBranch"
                            placeholder="Bank Branch"
                            value={beneficiaryBankDetails.bankBranch}
                            // onChange={(e) =>
                            //   setBankDetails({
                            //     ...bankDetails,
                            //     bankBranch: e.target.value,
                            //   })
                            // }
                            required
                            disabled
                          />
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="bankBranchCode">
                          Bank Branch Code
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            id="bankBranchCode"
                            placeholder="Bank Branch Code"
                            value={beneficiaryBankDetails.bankBranchCode}
                            // onChange={(e) =>
                            //   setBankDetails({
                            //     ...bankDetails,
                            //     bankBranch: e.target.value,
                            //   })
                            // }
                            required
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  )}

                <div className="col-md-12 mt-3">
                  <label className="form-label" htmlFor="validationCustom02">
                    Description
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className={`form-control ${
                        subBudgetDescriptionIsValid ? "is-invalid" : ""
                      }`}
                      id="validationCustom02"
                      placeholder="Description"
                      value={subBudgetDescription}
                      onChange={(e) => setSubBudgetDescription(e.target.value)}
                      required
                    />
                    {subBudgetDescriptionIsValid && (
                      <div className="invalid-feedback">
                        Please enter a description
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-body">
                  <FileUpload
                    onFileSelect={handleFileSelect}
                    clear={clearFileUploader}
                  />
                  {fieldErrors.file !== "" ? (
                    <div className="text-danger">{fieldErrors.file}</div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleClear}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                onClick={handleSubmit}
              >
                Request Sub-Budget
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default SubBudget;
